'use strict';
exports.default = exports;
const {ProcedureBillingType} = require('../status');

/**
 *
 * @typedef {Object} Field
 * @property {string} cOrigin - column name origin.
 * @property {string} cDestiny - column name destiny.
 * @property {(string|boolean|number|null|Array|undefined)} defaultValue - .
 * @property {string} type - ('string'|'boolean'|'number'|'Timestamp'|'Struct'|'StructFk'|'Array'|'ArrayFk'|'ArrayString'|'Original').
 * @property {string} [fk=null] - chave na listModels.
 * @property {Array<Field>|null} [items=null] - No caso de type==Struct, os items da struct
 * @property {Boolean} [removeBeforeSave=false]
 *
 */

/**
 @typedef {object} ConfigTable
 @property {string} name - Table name, used on refs.
 @property {string} tableDestiny - Table name to destiny.
 @property {string} tableOrigin: Table name of origin.
 @property {string} pKey - Primary key.
 @property {Array<Field>} fields - Fields on table
 @property {boolean} [preserveFields=false] - mantém os os campos não tratados.
 @property {boolean} [plainDestiny=false] - move os atributos das Structs para a raiz do objeto.
 @property {boolean} [preservePKey=false] - mantém o pKey no objeto.
 @property {function|null} [beforeProcess=null] - função que recebe uma row e retorna uma row antes da mesma ser processada
 @property {function|null} [afterProcess=null] - função que recebe uma row e retorna uma row depois da mesma ser processada
 */


/**
 *
 * @param {string} cOrigin
 * @param {string|null} cDestiny
 * @param {string} type - ('string'|'boolean'|'number'|'Timestamp'|'Struct'|'object'|'Array'|'ArrayFk'|'ArrayString'|'Original').
 * @param {string|boolean|number|null|Array|undefined} [defaultValue=null]
 * @param {string|null} [fk=null]
 * @param {Array<Field>} [items=null]
 * @param {Boolean} [removeBeforeSave=false]
 * @returns {Field}
 */
function setField(cOrigin, cDestiny, type, defaultValue=null, fk=null, items=null, removeBeforeSave=false) {
  return {cOrigin, cDestiny: cDestiny||cOrigin, type, defaultValue, fk, items, removeBeforeSave};
}


/**
 * @type {ConfigTable}
 */
exports.meta = {
  name: 'meta',
  tableDestiny: 'meta',
  tableOrigin: 'meta',
  pKey: 'id',
  preservePKey: true,
  preserveFields: true,
  fields: [
    setField('createdAt', null, 'Timestamp', null),
    setField('updatedAt', null, 'Timestamp', null),
    setField('deletedAt', null, 'Timestamp', null),

    setField('createdBy', null, 'string', ''),
    setField('deletedBy', null, 'string', ''),
    setField('updatedBy', null, 'string', ''),
    setField('createdByName', null, 'string', ''),
    setField('updatedByName', null, 'string', ''),
    setField('deletedByName', null, 'string', ''),
    setField('createdEnv', null, 'string', ''),
    setField('updatedEnv', null, 'string', ''),
    setField('updatedVersion', null, 'string', ''),
    setField('createdVersion', null, 'string', ''),
    setField('deletedEnv', null, 'string', ''),

    setField('updatedByAdmin', null, 'boolean', false),

    setField('addedToBatchAt', null, 'Timestamp', null),
    setField('addedToBatchBy', null, 'string', ''),
  ],
};

/**
 * @type {ConfigTable}
 */
exports.events = {
  name: 'events',
  tableDestiny: 'events',
  tableOrigin: 'events',
  schema: 'public',
  pKey: 'id',
  preservePKey: true,
  preserveFields: true,
  fields: [
    setField('id', null, 'string', null),
    setField('active', null, 'boolean', false),
    setField('shouldBeFollowUp', null, 'boolean', false),
    setField('goToScheduleCore', null, 'boolean', false),
    setField('isFollowUp', null, 'boolean', false),
    setField('followUpById', null, 'string', null),
    setField('meta', null, 'Struct', null,null,[
      setField('createdByCompanyType', null, 'string', ''),
    ]),
    setField('values', null, 'Struct', null,null,[
      setField('attendanceFee', null, 'Currency', 0),
      setField('attendanceFeeReceived', null, 'Currency', 0),
      setField('attendanceFeeLoss', null, 'Currency', 0),
      setField('complementation', null, 'Currency', 0),
      setField('complementationReceived', null, 'Currency', 0),
      setField('complementationLoss', null, 'Currency', 0),

      setField('expenses', null, 'Currency', 0),
      setField('expensesReceived', null, 'Currency', 0),
      setField('expensesOver', null, 'Currency', 0),
      setField('expensesGlosado', null, 'Currency', 0),
      setField('expensesLoss', null, 'Currency', 0),
      setField('expensesDiscount', null, 'Currency', 0),

      setField('totalProcedures', null, 'Currency', 0),
      setField('totalProceduresReceived', null, 'Currency', 0),
      setField('totalProceduresOver', null, 'Currency', 0),
      setField('totalProceduresGlosado', null, 'Currency', 0),
      setField('totalProceduresLoss', null, 'Currency', 0),

      setField('totalReceived', null, 'Currency', 0),
      setField('totalOver', null, 'Currency', 0),
      setField('totalLoss', null, 'Currency', 0),
      setField('totalGlosado', null, 'Currency', 0),
      setField('totalProduced', null, 'Currency', 0),
      setField('totalInProcessing', null, 'Currency', 0),
      setField('valueChanged', null, 'Currency', 0),
      setField('totalChangedPlus', null, 'Currency', 0),
      setField('totalChangedLess', null, 'Currency', 0),
      setField('totalDiscount', null, 'Currency', 0),
    ]),
    setField('status', null, 'Struct', null,null,[
      setField('hasCuted', null, 'boolean', false),
      setField('isProcessing', null, 'boolean', false),
      setField('urgent', null, 'boolean', false),
      setField('hasComplementation', null, 'boolean', false),
      setField('alertSendRecourse', null, 'boolean', false),
      setField('alertReceive', null, 'boolean', false),
      setField('isLocked', null, 'boolean', false),
      setField('hasLoss', null, 'boolean', false),
      setField('status', null, 'string', 'AwaitingCheck'),
      setField('recourseSent', null, 'boolean', false),
      setField('guiaSent', null, 'boolean', false),
      setField('recourseIdentify', null, 'boolean', false),
      setField('received', null, 'boolean', false),
      setField('alertSendGuia', null, 'boolean', false),
    ]),
    setField('patient', null, 'StructFk', null,'patients'),
    setField('procedures', null, 'ArrayFk', null,'procedures'),

    setField('dtProcedure', null, 'Timestamp', null),
    setField('dtRecourse', null, 'Timestamp', null),

    setField('companyId', null, 'string', null,'companies'),
    setField('healthInsuranceId', null, 'string', null,'healthInsurance'),
    setField('hospitalId', null, 'string', null,'hospitals'),
    setField('patientId', null, 'string', null,'patients'),
    setField('anesthetistId', null, 'string', null,'anesthetists'),
    setField('surgeonId', null, 'string', null,'surgeon'),
    setField('protocolId', null, 'string', null),

    setField('type', null, 'string', null),
    setField('observationGuideSent', null, 'string', null),
    setField('numGuide', null, 'string', null),
    setField('observationRecourse', null, 'string', null),
    setField('accommodation', null, 'string', null),
    setField('healthInsuranceWallet', null, 'string', ''),

    setField('observations', null, 'Array', []),
    setField('invoices', null, 'Array', []),
    setField('batchesIds', null, 'ArrayString', []),
    setField('invoicesIds', null, 'ArrayString', []),
    setField('revenueIds', null, 'ArrayString', []),
    setField('revenueTypes', null, 'ArrayString', []),

    setField('integrationProceduresCodes', null, 'Original', undefined, null, null, true),
    setField('statusHistory', null, 'Array', undefined, null, null, true),

    setField('tmpDtProcedureSeconds', null, 'Original', undefined, null, null, true),

    setField('multAdditionalData', null, 'Array', undefined, null, null),
    setField('procedureTeamTabs', null, 'Array', undefined, null, null),

    // Para resumos
    setField('healthInsurance', null, 'Original', undefined, null, null),
    setField('anesthetist', null, 'Original', undefined, null, null),
    setField('surgeon', null, 'Original', undefined, null, null),
    setField('hospital', null, 'Original', undefined, null, null),
  ],
};

/**
 * @type {ConfigTable}
 */
exports.patients = {
  name: 'patients',
  tableDestiny: 'patients',
  tableOrigin: 'patients',
  pKey: 'id',
  preservePKey: true,
  preserveFields: true,
  fields: [
    setField('id', null, 'string', null),
    setField('meta', null, 'StructFk', null,'meta'),
    setField('active', null, 'boolean', false),
    setField('companyId', null, 'string', null,'companies'),
    setField('companyIds', null, 'Array', [],'companies'),
    setField('cpf', null, 'string', ''),
    setField('gender', null, 'string', ''),
    setField('name', null, 'string', ''),
    setField('momName', null, 'string', ''),
    setField('birthDate', null, 'Timestamp', null),
    setField('birthDateIso', null, 'string', null),
    setField('profileImageUrl', null, 'string', null),
    setField('healthInsuranceId', null, 'string', null),
    setField('healthInsuranceWallet', null, 'string', null),
    setField('email', null, 'string', ''),
    setField('accommodation', null, 'string', 'NURSERY'),
    setField('nameLowerCase', null, 'string', ''),
    setField('phone', null, 'string', ''),
  ],
};
/**
 * @type {ConfigTable}
 */
exports.procedures = {
  name: 'procedures',
  tableDestiny: 'procedures',
  tableOrigin: 'procedures',
  pKey: 'id',
  preservePKey: true,
  preserveFields: true,
  fields: [
    setField('id', null, 'string', null),
    setField('idProcGroupedByPort', null, 'string', null),
    setField('active', null, 'boolean', false),
    setField('skipAppeal', null, 'boolean', false),

    setField('revenueTeam', null, 'Array', []),
    setField('procedures', null, 'Array', []),

    setField('updatedAt', null, 'Timestamp', null),
    setField('useAsCBHPM', null, 'boolean', false),
    setField('type', null, 'string', ''),
    setField('techniqueUsed', null, 'string', ''),
    setField('techniqueUsedProportion', null, 'number', 1),
    setField('idGrupo', null, 'string', ''),
    setField('name', null, 'string', ''),
    setField('porte', null, 'string', ''),
    setField('indicadorAnestesico', null, 'string', ''),
    setField('typeValue', null, 'string', ''), // Este campo é utilizado somente quando é um pacote
    setField('invoice', null, 'string', null),
    setField('invoicesIds', null, 'ArrayString', []),
    setField('cuteReasonIds', null, 'ArrayString', []),
    setField('idProc', null, 'string', ''),
    setField('totalReceived', null, 'number', ''),
    setField('createdEnv', null, 'string', ''),
    setField('tableCode', null, 'string', ''),
    setField('typeValue', null, 'string', ''),
    setField('porteAnestesico', null, 'number', -1),
    setField('order', null, 'number', 0),
    setField('updatedEnv', null, 'string', ''),
    setField('procedimento', null, 'string', ''),
    setField('rowId', null, 'string', ''),
    setField('procedureTeamId', null, 'string', null),
    setField('userCustom', null, 'string', ''),
    setField('proportion', null, 'number', 1),
    setField('portePercent', null, 'number', 1),
    setField('qtdAux', null, 'number', -1),
    setField('uco', null, 'number', -1),
    setField('participative', null, 'number', 0),

    setField('valueOriginal', null, 'Currency', 0),
    setField('value', null, 'Currency', 0),
    setField('valueBase', null, 'Currency', 0),
    setField('valueTable', null, 'Currency', 0),
    setField('valueChanged', null, 'Currency', 0),

    setField('totalReceived', null, 'Currency', 0),
    // `procedures` entra como ArrayFk, e getArrayFk chama getStructFk sem repassar
    // preserveFields: campo não declarado aqui é descartado no save. calculateEventValues
    // sempre cria `totalReceivedFromOver` em memória, então sem esta linha o campo nascia
    // no cálculo e morria na gravação — e o verificador acusava "added" em todo evento.
    setField('totalReceivedFromOver', null, 'Currency', 0),
    setField('totalOver', null, 'Currency', 0),
    setField('totalGlosado', null, 'Currency', 0),
    setField('totalLoss', null, 'Currency', 0),
    setField('totalDiscount', null, 'Currency', 0),
    setField('billingType', null, 'string', ProcedureBillingType.BILLABLE),  // Default to BILLABLE for backward compatibility
  ],
};




/**
 * @type {ConfigTable}
 */
exports.exemplo = {
  name: 'exemplo',
  tableDestiny: 'companyEventos',
  tableOrigin: 'company_eventos',
  pKey: 'id',
  preserveFields: false,
  preservePKey: false,
  fields: [
    setField('id', 'id', null, 'string'),
    setField('coluna_origem', 'coluna_destino', null, 'string'),
  ],
  beforeProcess: function(row) {
    switch(row.type) {
      case 'convenio_procedimentos_customizados':
        row.convenio_procedimentos_customizados = row.procedimento;
        delete row.procedimento;
        break;
      case 'convenio_codigos_especiais':
        row.convenio_codigos_especiais = row.procedimento;
        delete row.procedimento;
        break;
    }
    return row;
  },
  afterProcess(row) {
    return row;
  }
};


